import type {
  NETProcedure,
  TargetFormValues,
  TaskAnalysisProcedure,
} from "../../TargetBuilderPanel.types";

export function getHiddenPromptHierarchyNetPatch(
  procedure: NETProcedure,
  l1: TargetFormValues["l1_dimension"]
): Partial<NETProcedure> | null {
  const hasLevels = (procedure.prompt_hierarchy?.levels?.length ?? 0) > 0;
  const shouldForceCounterType = l1 === "latency";
  const nextCounterType = shouldForceCounterType
    ? "correct_incorrect"
    : procedure.counter_type === "prompt-hierarchy"
      ? "correct_incorrect"
      : procedure.counter_type;

  if (!hasLevels && procedure.counter_type === nextCounterType) return null;

  return {
    ...(nextCounterType ? { counter_type: nextCounterType } : {}),
    prompt_hierarchy: { ...procedure.prompt_hierarchy, levels: [] },
  };
}

export function getHiddenPromptHierarchyTaskAnalysisPatch(
  procedure: TaskAnalysisProcedure
): Partial<TaskAnalysisProcedure> | null {
  if (procedure.step_scoring !== "prompt-hierarchy") return null;

  return {
    step_scoring: "binary",
    prompt_hierarchy: { ...procedure.prompt_hierarchy, levels: [] },
  };
}
